import {
  ConnectTerminalHardwareOrders,
  ConnectTerminalHardwareShop,
} from '@/components/stripe-connect/StripeConnectTerminalHardware'
import {
  STRIPE_CONNECT_CARD_READER_SECTIONS,
  STRIPE_CONNECT_DASHBOARDLESS_SECTIONS,
} from '@/components/stripe-connect/stripeConnectSurfaceContent'
import { createFileRoute } from '@tanstack/react-router'
import { ShoppingBag } from 'lucide-react'
import { DashboardlessStripePage, dashboardlessStripeRouteLoader } from './-dashboardless-page'

export const Route = createFileRoute('/_authenticated/$orgId/settings/stripe/card-readers')({
  component: StripeCardReadersPage,
  loader: dashboardlessStripeRouteLoader,
})

// Stripe's orders list loads on mount and lags a new checkout, so a new order appears on the next visit.
export function StripeCardReadersPage() {
  return (
    <DashboardlessStripePage
      {...STRIPE_CONNECT_DASHBOARDLESS_SECTIONS.cardReaders}
      icon={ShoppingBag}
      sections={[
        { ...STRIPE_CONNECT_CARD_READER_SECTIONS.shop, component: ConnectTerminalHardwareShop },
        { ...STRIPE_CONNECT_CARD_READER_SECTIONS.orders, component: ConnectTerminalHardwareOrders },
      ]}
      surface="card-readers"
    />
  )
}
